import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SimPageTemplateComponent } from '../main-layout/sim-page-template.component';
import { PageTemplateLayout } from '../tokens/layout.token';

@Component({
  imports: [SimPageTemplateComponent],
  template: `<layout-page-template />`,
  styles: `
    layout-page-template {
      --content-max-width: 100%;
    }
    ::ng-deep common-content.content {
      --content-max-width: 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: PageTemplateLayout,
      useExisting: FullWidthLayoutComponent
    }
  ]
})
export class FullWidthLayoutComponent extends SimPageTemplateComponent {}
